import React from 'react';
import {WideHeader} from '../../layout/wide';

const TermsOfService: React.FC = () => {
  return (
    <>
      <WideHeader
        title="Regulamin Świadczenia Usług"
        introduction="Terms of Service for Baza Witraży"
        narrow={true}
      />

      <section className="bg-gray-100 py-8">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="bg-white rounded-lg shadow-sm p-8">
            <div className="text-gray-700 leading-relaxed space-y-6">
              <div>
                <h2 className="text-2xl font-cinzel font-bold text-gray-900 mb-4">
                  Regulamin Świadczenia Usług Drogą Elektroniczną Serwisu „Baza Witraży"
                </h2>
              </div>

              <div>
                <h3 className="text-xl font-cinzel font-bold text-gray-900 mb-3">
                  § 1. Postanowienia Ogólne
                </h3>
                <ol className="list-decimal pl-6 space-y-2">
                  <li>
                    Niniejszy Regulamin określa zasady świadczenia usług drogą elektroniczną przez Serwis „Baza Witraży" 
                    (zwany dalej "Serwisem").
                  </li>
                  <li>
                    Usługodawcą jest <strong>Corpus Vitrearum Polska</strong> z siedzibą w <strong>ul. Grodzka 53, 
                    31-001 Kraków</strong> (zwany dalej "Usługodawcą").
                  </li>
                  <li>
                    Serwis działa pod adresem internetowym <strong>http://baza-witrazy.uj.edu.pl</strong>.
                  </li>
                  <li>
                    Usługobiorcą jest każda osoba fizyczna, która zakłada Konto w Serwisie (zwana dalej "Użytkownikiem").
                  </li>
                  <li>
                    Kontakt z Usługodawcą jest możliwy poprzez adres e-mail: <a href="mailto:cvp@uj.edu.pl" 
                    className="text-blue-600 hover:underline">cvp@uj.edu.pl</a>.
                  </li>
                </ol>
              </div>

              <div>
                <h3 className="text-xl font-cinzel font-bold text-gray-900 mb-3">
                  § 2. Rodzaje i Zakres Usług
                </h3>
                <ol className="list-decimal pl-6 space-y-2">
                  <li>
                    Usługodawca świadczy na rzecz Użytkownika nieodpłatne usługi polegające na:
                    <ol className="list-[lower-alpha] pl-6 mt-2 space-y-1">
                      <li>Prowadzeniu Konta Użytkownika w Serwisie.</li>
                      <li>Umożliwieniu Użytkownikowi zapisywania wybranych obiektów (witraży) jako „Ulubione".</li>
                      <li>Umożliwieniu Użytkownikowi tworzenia, edytowania i zarządzania własnymi „Kolekcjami" obiektów.</li>
                      <li>Udostępnieniu funkcji edycji danych Konta (zmiana Imienia, Nazwiska, adresu e-mail).</li>
                      <li>Udostępnieniu funkcji zmiany i odzyskiwania (przypomnienia) hasła do Konta.</li>
                    </ol>
                  </li>
                  <li>
                    Do korzystania z usług wymagane jest posiadanie statusu zalogowanego Użytkownika.
                  </li>
                </ol>
              </div>

              <div>
                <h3 className="text-xl font-cinzel font-bold text-gray-900 mb-3">
                  § 3. Warunki Świadczenia Usług i Rejestracja
                </h3>
                <ol className="list-decimal pl-6 space-y-2">
                  <li>
                    W celu zawarcia umowy o świadczenie usług (założenia Konta), Użytkownik musi:
                    <ol className="list-[lower-alpha] pl-6 mt-2 space-y-1">
                      <li>Wypełnić formularz rejestracyjny, podając co najmniej aktywny adres e-mail oraz hasło.</li>
                      <li>Zaakceptować niniejszy Regulamin oraz zapoznać się z Polityką Prywatności.</li>
                    </ol>
                  </li>
                  <li>
                    Akceptacja Regulaminu przez Użytkownika jest równoznaczna ze złożeniem oświadczenia woli o chęci 
                    zawarcia umowy z Usługodawcą.
                  </li>
                  <li>
                    Użytkownik zobowiązany jest do zachowania swojego hasła w tajemnicy i nieudostępniania go osobom trzecim.
                  </li>
                  <li>
                    Wymagania techniczne niezbędne do korzystania z Serwisu to:
                    <ol className="list-[lower-alpha] pl-6 mt-2 space-y-1">
                      <li>Dostęp do sieci Internet.</li>
                      <li>Aktualna wersja przeglądarki internetowej (np. Google Chrome, Mozilla Firefox, Safari, Edge).</li>
                      <li>Aktywne konto poczty elektronicznej (e-mail).</li>
                    </ol>
                  </li>
                  <li>
                    Zakazane jest dostarczanie przez Użytkownika treści o charakterze bezprawnym.
                  </li>
                </ol>
              </div>

              <div>
                <h3 className="text-xl font-cinzel font-bold text-gray-900 mb-3">
                  § 4. Czas Trwania i Rozwiązanie Umowy
                </h3>
                <ol className="list-decimal pl-6 space-y-2">
                  <li>
                    Umowa o świadczenie usług (prowadzenie Konta) zawierana jest na czas nieokreślony.
                  </li>
                  <li>
                    Użytkownik ma prawo rozwiązać umowę w dowolnym momencie i bez podania przyczyny.
                  </li>
                  <li>
                    Rozwiązanie umowy następuje poprzez samodzielne usunięcie Konta przez Użytkownika (za pomocą odpowiedniej 
                    opcji w panelu Konta) lub poprzez przesłanie żądania usunięcia Konta na adres e-mail Usługodawcy.
                  </li>
                  <li>
                    Usunięcie Konta jest trwałe i powoduje bezpowrotną utratę wszystkich zapisanych danych (w tym Ulubionych 
                    i Kolekcji).
                  </li>
                </ol>
              </div>

              <div>
                <h3 className="text-xl font-cinzel font-bold text-gray-900 mb-3">
                  § 5. Postępowanie Reklamacyjne
                </h3>
                <ol className="list-decimal pl-6 space-y-2">
                  <li>
                    Użytkownik ma prawo do złożenia reklamacji dotyczących działania Serwisu.
                  </li>
                  <li>
                    Reklamacje należy składać drogą elektroniczną na adres e-mail Usługodawcy: <a href="mailto:cvp@uj.edu.pl" 
                    className="text-blue-600 hover:underline">cvp@uj.edu.pl</a>.
                  </li>
                  <li>
                    Reklamacja powinna zawierać co najmniej adres e-mail Użytkownika oraz opis zgłaszanego problemu.
                  </li>
                  <li>
                    Usługodawca rozpatrzy reklamację w terminie 14 (czternastu) dni roboczych od dnia jej otrzymania.
                  </li>
                </ol>
              </div>

              <div>
                <h3 className="text-xl font-cinzel font-bold text-gray-900 mb-3">
                  § 6. Postanowienia Końcowe
                </h3>
                <ol className="list-decimal pl-6 space-y-2">
                  <li>
                    Zasady przetwarzania danych osobowych Użytkowników są szczegółowo opisane w dokumencie „Polityka 
                    Prywatności", dostępnym na stronach Serwisu.
                  </li>
                  <li>
                    Usługodawca zastrzega sobie prawo do zmiany niniejszego Regulaminu z ważnych przyczyn (np. zmiana 
                    funkcjonalności Serwisu, zmiana przepisów prawa).
                  </li>
                  <li>
                    O zmianie Regulaminu Użytkownicy zostaną poinformowani drogą elektroniczną (na adres e-mail podany 
                    przy rejestracji) z co najmniej 7-dniowym wyprzedzeniem.
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TermsOfService;

